import { useState } from "react";
import { ChevronDown } from "lucide-react";

const DashboardSection = ({ title, subtitle, children, headerActions, displayAccordion = true }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="db-section db-section-card">
      <div className="db-section-header">
        <div className="db-section-title-group">
          <h3 className="db-section-title">{title}</h3>
          {subtitle && <p className="db-section-subtitle">{subtitle}</p>}
        </div>
        <div className="db-section-header-right">
          {headerActions && <div className="db-section-header-actions">{headerActions}</div>}
          {displayAccordion && (
            <button
              className="db-collapse-btn"
              onClick={() => setCollapsed(!collapsed)}
              aria-label="Toggle section"
            >
              <ChevronDown
                size={20}
                strokeWidth={2}
                className={`collapse-icon ${collapsed ? "collapsed" : ""}`}
              />
            </button>
          )}
        </div>
      </div>
      {!collapsed && <div className="db-section-body">{children}</div>}
    </div>
  );
};

export default DashboardSection;
